<div class="wrapper-page faq-page">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <span class="header-text">Baneri</span>
      <button class="zc-btn zc-btn--primary" (click)="isCreateBannerModalOpen = true"><span>Dodaj banner</span></button>
    </div>
    <div class="grid__m-12">
      <div class="zc-wrapper-tabs">
        <div class="zc-tab" [ngClass]="{'active': activeTab === BannerTypeEnum.application}" (click)="activeTab = BannerTypeEnum.application">
          <span>Aplikacija</span>
        </div>
        <div class="zc-tab" [ngClass]="{'active': activeTab === BannerTypeEnum.landing}" (click)="activeTab = BannerTypeEnum.landing">
          <span>Landing</span>
        </div>
      </div>
    </div>
    <gr-banners-in-app
      [hidden]="activeTab === BannerTypeEnum.landing"
      [isBannerChange]="activeTab === BannerTypeEnum.application && isBannerChange"
      (bannerForEdit)="bannerForEdit = $event"
      (bannerForDelete)="bannerForDelete = $event">
    </gr-banners-in-app>
    <gr-banners-on-landing
      [hidden]="activeTab === BannerTypeEnum.application"
      [isBannerChange]="activeTab === BannerTypeEnum.landing && isBannerChange"
      (bannerForEdit)="bannerForEdit = $event"
      (bannerForDelete)="bannerForDelete = $event">
    </gr-banners-on-landing>
  </div>

  <gr-confirm-modal
    *ngIf="bannerForDelete !== null"
    [modalTitle]="'Brisanje bannera'"
    [modalDescription]="'Da li ste sigurni da zelite da obrišete banner?'"
    (closeModal)="bannerForDelete = null"
    (confirmModal)="onConfirmDeleteBanner()"
  ></gr-confirm-modal>

  <gr-create-or-edit-banner-modal
    *ngIf="isCreateBannerModalOpen || bannerForEdit !== null"
    [activeTab]="activeTab"
    [bannerForEdit]="bannerForEdit"
    (closeModal)="isCreateBannerModalOpen = false; bannerForEdit = null"
    (confirmModal)="onConfirmCreateOrEditBanner()"
  ></gr-create-or-edit-banner-modal>
</div>


